<template>
  <v-dialog
    :value="dashboardActive"
    @input="close()"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <template>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Dashboard</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="10">
              <v-data-table
                :headers="headers"
                :items="dashboardTable.items"
                :options.sync="options"
                :loading="loading.dashboardTable"
                :footer-props="{
                  showFirstLastPage: true,
                  firstIcon: 'mdi-page-first',
                  lastIcon: 'mdi-page-last',
                  prevIcon: 'mdi-chevron-left',
                  nextIcon: 'mdi-chevron-right',
                  itemsPerPageOptions: [5, 10, 20, 50],
                  itemsPerPageText: 'Linhas por página:',
                  pageText: `${
                    (options.page - 1) * options.itemsPerPage + 1
                  } a ${Math.min(
                    dashboardTable.items.length,
                    options.page * options.itemsPerPage
                  )} de ${dashboardTable.items.length}`,
                }"
                no-data-text="Sem dados disponíveis"
                loading-text="Carregando..."
                class="elevation-1"
              >
              </v-data-table>
              <div class="text-center pt-2">
                <v-btn color="primary" class="mr-2" @click="download()">
                  Download
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import XLSX from "xlsx";

export default {
  name: "Dashboard",

  data: () => ({
    listDownload: false,
    options: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: [
      {
        text: "Regional",
        sortable: false,
        align: "start",
        value: "regional_loja",
      },
      {
        text: "Área",
        sortable: false,
        align: "start",
        value: "Area",
      },
      {
        text: "Novos",
        value: "Novos",
      },
      {
        text: "Atrasados",
        value: "Atrasados",
      },
      {
        text: "Concluidos",
        value: "Concluidos",
      },
      {
        text: "Total",
        value: "Total",
      },
      { text: "", sortable: false, value: "actions" },
    ],
  }),
  computed: {
    ...mapState(["dashboardActive", "loading", "dashboardTable"]),
  },

  methods: {
    ...mapMutations(["setDashboardActive"]),
    ...mapActions(["getDashboardTable"]),

    close() {
      this.setDashboardActive({ setDashboardActive: false });
    },

    download() {
      const filename = `Monitoramento ${new Date().toISOString()}.xlsx`;
      this.loading = true;
      const entrevistas = XLSX.utils.json_to_sheet(
        this.$store.state.dashboardTable.items
      );

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, entrevistas, "Entrevistas");

      XLSX.writeFile(workbook, filename);
    },
  },
};
</script>
